/* eslint-disable space-infix-ops */
import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import {findDOMNode} from 'react-dom';
import { getEmptyImage } from 'react-dnd-html5-backend';
import _ from 'lodash';

const ItemTypes = {
  GALLERY_ORGANIZER_ITEM: 'galleryOrganizerItem',
};

const sourceFunctions = {
  beginDrag(props, monitor, PureComponent) {
    props.onDragStart(props.order, PureComponent);
    return {
      order: props.order
    };
  },
  endDrag(props, monitor, PureComponent) {
    props.onDragEnd();
  }
};

const EnhancedAbsoluteGridTile = @DragSource(ItemTypes.GALLERY_ORGANIZER_ITEM, sourceFunctions, (connect) => {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
  };
})
class AbsoluteGridTile extends PureComponent {

  state = {
    differenceFromInitialOffset: null,
  };

  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  }

  componentWillUpdate(nextProps, nextState) {
  }

  setDifferenceFromInitialOffset = (differenceFromInitialOffset) => {
    this.setState({differenceFromInitialOffset});
  };

  render() {
    const {differenceFromInitialOffset} = this.state;
    let {top, left} = this.props.style;
    const style = _.omit(this.props.style, ['top', 'left']);
    if (differenceFromInitialOffset) {
      top += differenceFromInitialOffset.y;
      left += differenceFromInitialOffset.x;
      style.zIndex = 1;
      style.cursor = '-webkit-grab';
      style.transition = null;
    }
    style.transform = `translate3d(${left}px, ${top}px, 0px)`;
    // we bind the onClickRemove to the item here to avoid unwanted renders.
    const {children} = this.props;
    const {connectDragSource} = this.props;
    return connectDragSource(<div style={style}>
      {children}
      </div>
    );
  }
};

export default EnhancedAbsoluteGridTile;

EnhancedAbsoluteGridTile.propTypes = {
  onDragStart: PropTypes.func.isRequired,
  onDragTargetChange: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  style: PropTypes.object,
};

EnhancedAbsoluteGridTile.defaultProps = {
  onDragStart: () => {},
  onDragTargetChange: () => {},
  onDragEnd: () => {},
};